<template>
  <div class="cart-item-remove-popup">
    <h1 class="remove-popup-title">{{ dataTitle }}</h1>
    <div class="d-flex align-items-start plr16 justify-content-between pt5">
      <div class="d-flex align-items-start">
        <img
          :src="[
            dataItem?.isVeg
              ? staticImgBaseUrl + '/images/global/tag-veg.svg'
              : staticImgBaseUrl + '/images/global/tag-non-veg.svg',
          ]"
          class="mr8 mt5"
          loading="lazy"
          alt="default image"
        />
        <div>
          <p class="fs-14 fw-700">{{ dataItem?.displayName }}</p>

          <div class="d-flex justify-content-between align-items-center mt5">
            <div v-if="isOnCartPage && dataItem?.selectedComboVariant">
              <ul
                class="fs-11 lh18"
                v-for="(
                  comboVariantName, comboVariantNameIndex
                ) in dataItem?.selectedComboVariant"
                :key="comboVariantNameIndex"
              >
                <li class="color-grey">
                  <span>1pc - {{ comboVariantName }} </span>
                </li>
              </ul>
            </div>
            <ul
              v-else-if="itemsInCombo"
              class="justify-content-between fs-12 lh18"
            >
              <li
                class="color-grey"
                v-for="(item, index) in itemsInCombo"
                :key="index"
              >
                1pc - {{ productObj[item]?.displayName }}
              </li>
            </ul>
            <ul v-else class="justify-content-between fs-12 lh18">
              <li class="color-grey disc-list">
                {{ dataItem?.selectedVariant?.displayName }}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="d-flex flex-column mt5">
        <div class="d-flex gap4">
          <div class="tr" v-if="currentPrice !== regularPrice">
            <span class="color-grey fs-10">
              <i class="rs">Rs.</i
              ><span class="strike-diagonal-price">
                {{ parseFloat(regularPrice.toFixed(2)) }}
              </span>
            </span>
          </div>
          <div class="product-price">
            <i class="rs" v-if="currentPrice != 'Free'">Rs.</i>
            <span :class="{ 'color-error': currentPrice == 'Free' }">
              {{ parseFloat(currentPrice.toFixed(2)) }}
            </span>
          </div>
        </div>
        <div class="savings mt5" v-if="currentPrice !== regularPrice">
          <span class="fs-10 normal">
            <i class="rs fw-700">Rs.</i
            ><span class="fw-700">
              {{ parseFloat((regularPrice - currentPrice).toFixed(2)) }}
            </span>
          </span>
          <span class="fw-700 fs-10">SAVED</span>
        </div>
      </div>
    </div>

    <div
      class="customise-repeat-bottom d-flex justify-content-between plr16 mt8"
    >
      <div
        class="line-btn sm repeat-btn br8"
        @click="closeItemRemovePopup"
        v-ripple
      >
        Keep It
      </div>
      <div
        class="line-btn sm repeat-btn secondary br8"
        @click="$emit('removeItemFromCart')"
        v-ripple
      >
        {{ dataAction }}
      </div>
    </div>
  </div>
</template>
<script>
import { keyMapsMutation } from "../helpers/storeKeys";
import { EVENT_CART_CLICK_REMOVE_LAST_ITEM } from "../helpers/analyticsEvents";
import { staticImgBaseUrl } from "../config/apiEndpoints";
import Utility from "../helpers/utility";
export default {
  name: "ItemRemovePopup",
  props: ["dataTitle", "dataItem", "dataAction", "dataPaddingLeft"],
  data() {
    return {
      staticImgBaseUrl,
      productObj: {},
      productsFilteredArray: [],
    };
  },
  mounted() {
    document.body.classList.add("body-stop-scroll-mobile");
    EVENT_CART_CLICK_REMOVE_LAST_ITEM({ userAction: "Launch" });

    this.productsFilteredArray = Object.values(
      this.$store.state.ProductItems.productsFiltered,
    );
    this.productObj = this.productsFilteredArray.reduce(
      (pv, cv) => Object.assign(pv, cv),
      {},
    );
  },
  methods: {
    closeItemRemovePopup() {
      this.$store.commit(
        keyMapsMutation.UPDATE_REMOVE_ITEM_CART_POPUP_SELECTED,
        false,
      );

      EVENT_CART_CLICK_REMOVE_LAST_ITEM({ userAction: "Close" });
      this.$store.commit(keyMapsMutation.UPDATE_SELECTED_ITEM_IN_CART, {});
      document.body.classList.remove("body-stop-scroll-mobile");
    },
  },
  computed: {
    currentPrice() {
      return (
        this.dataItem?.calculations?.find((x) => x.key == "current_price")
          ?.amount ??
        this.dataItem?.selectedVariant?.price?.currentPrice ??
        this.dataItem?.price?.currentPrice
      );
    },
    regularPrice() {
      return (
        this.dataItem?.calculations?.find((x) => x.key == "regular_price")
          ?.amount ??
        this.dataItem?.selectedVariant?.price?.regularPrice ??
        this.dataItem?.price?.regularPrice
      );
    },
    isOnCartPage() {
      return Utility.isCurrentlyAtUrl("/cart");
    },
    itemsInCombo() {
      let productItemsIdArray = this.dataItem?.selectedComboVariant
        ?.map((x) => x?.items?.map((i) => i?.parentSkuId))
        .flat();
      return productItemsIdArray;
    },
  },
};
</script>
